// Mock data for VA Éditions / Quid Novi website

export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      about: "Notre Maison",
      authors: "Auteurs",
      team: "L'Équipe",
      catalog: "Catalogue",
      contact: "Contact"
    },
    home: {
      hero: {
        title: "Quid Novi",
        subtitle: "Transmettre la connaissance, faire vivre les idées",
        description: "Quid Novi est une maison d'édition indépendante consacrée aux sciences humaines et sociales : histoire, économie, faits de société, pensée politique et analyse contemporaine.\n\nApolitique, notre ligne éditoriale vise à offrir un espace d'expression à des auteurs venus d'horizons intellectuels variés, afin d'alimenter le débat démocratique par la confrontation des idées et la rigueur de la réflexion.\n\nÀ la croisée du monde universitaire, de la recherche et de la pensée publique, nous avons pour vocation de transmettre des analyses exigeantes, accessibles et utiles à la compréhension du monde contemporain."
      },
      whoweare: {
        title: "Qui sommes-nous ?",
        content: "Nous sommes à l'origine à la croisée du monde universitaire et entrepreneurs. Nous sommes passionnés par les livres et la vie des idées. Nous avons créé Quid Novi par vocation, pas pour en vivre, mais pour permettre le débat d'idées et la transmission de connaissance. Le livre reste le plus beau véhicule de la pensée."
      },
      values: {
        title: "Nos Valeurs",
        items: [
          {
            title: "Transmettre la connaissance",
            description: "Permettre l'accès au savoir à travers des livres de qualité",
            icon: "book"
          },
          {
            title: "Favoriser le débat démocratique",
            description: "Nourrir le débat public avec des idées de fond",
            icon: "compass"
          },
          {
            title: "Proximité avec les auteurs",
            description: "Construire une relation de confiance et d'accompagnement",
            icon: "heart"
          },
          {
            title: "Indépendance",
            description: "Libres de nos choix éditoriaux, nous publions ce en quoi nous croyons",
            icon: "feather"
          }
        ]
      },
      collections: {
        title: "Nos Collections",
        subtitle: "Des livres qui explorent, questionnent, enrichissent",
        items: [
          { 
            name: "Politique", 
            description: "Analyses politiques et géopolitiques",
            image: "https://images.unsplash.com/photo-1567943183748-3a7542120c90"
          },
          { 
            name: "Histoire", 
            description: "Récits et réflexions sur notre passé",
            image: "https://images.pexels.com/photos/35268841/pexels-photo-35268841.jpeg"
          },
          { 
            name: "Faits de société", 
            description: "Enquêtes et témoignages sur le monde actuel",
            image: "https://images.pexels.com/photos/14534046/pexels-photo-14534046.jpeg"
          },
          { 
            name: "Économie", 
            description: "Comprendre les mutations économiques",
            image: "https://images.unsplash.com/photo-1519662978799-2f05096d3636"
          }
        ]
      },
      cta: {
        title: "Vous voulez devenir auteur ?",
        subtitle: "Transmettez-nous votre manuscrit",
        button: "Soumettre mon manuscrit"
      }
    },
    about: {
      title: "À propos de Quid Novi",
      subtitle: "Un éditeur généraliste indépendant",
      content: [
        "Quid Novi est un éditeur généraliste indépendant qui se fixe pour mission de transmettre le savoir au travers de livres traditionnels et numériques, y compris sur des sujets pointus.",
        "Chaque livre doit intégrer une collection qui a sa charte graphique propre. Les livres sont diffusés en librairie par notre diffuseur.",
        "Nous sommes également connus sous le nom de VA Éditions pour certaines de nos publications."
      ],
      values: {
        title: "Nos Valeurs",
        items: [
          { title: "Excellence éditoriale", description: "Qualité et rigueur dans chaque publication" },
          { title: "Indépendance", description: "Liberté de choix et d'expression" },
          { title: "Transmission", description: "Partager le savoir avec le plus grand nombre" },
          { title: "Innovation", description: "Formats traditionnels et numériques" }
        ]
      }
    },
    authors: {
      title: "Processus de Publication",
      subtitle: "De votre manuscrit au livre en librairie",
      intro: "Vous avez un manuscrit ? Découvrez notre processus de publication.",
      process: {
        title: "Les 5 Étapes",
        steps: [
          {
            number: "01",
            title: "Soumettre votre manuscrit",
            description: "Envoyez-nous votre manuscrit via notre formulaire de contact."
          },
          {
            number: "02",
            title: "Passage en comité éditorial",
            description: "Votre manuscrit est évalué par notre comité sous deux semaines."
          },
          {
            number: "03",
            title: "Dialogue éditorial",
            description: "En cas d'acceptation, nous travaillons ensemble sur votre texte."
          },
          {
            number: "04",
            title: "Impression",
            description: "Une fois finalisé, votre livre part en impression."
          },
          {
            number: "05",
            title: "Diffusion en librairie",
            description: "Votre livre est distribué dans les librairies par notre diffuseur."
          }
        ]
      },
      requirements: {
        title: "Exigences du Manuscrit",
        format: {
          title: "Format",
          items: [
            "Document WORD au format A5 (14,8 x 21 cm)",
            "100 à 350 pages",
            "130 000 à 500 000 caractères (espaces non compris)",
            "Police Times New Roman taille 12",
            "Marges : haut 2, bas 2, intérieur 2, extérieur 2, reliure 1"
          ]
        },
        structure: {
          title: "Structure",
          items: [
            "2 pages blanches au début et à la fin",
            "Page 3 : Prénom NOM, TITRE, sous-titre, « VA Éditions »",
            "Page 5 : sommaire",
            "Numérotation en pied de page (centré, à partir du bas : 1,25)"
          ]
        }
      },
      argumentaire: {
        title: "Fiche Argumentaire",
        description: "Pour présenter votre ouvrage à nos commerciaux, vous devrez créer une fiche argumentaire 5 mois avant la sortie :",
        items: [
          "Résumé concis (max 1000 caractères)",
          "Points forts (4 maximum)",
          "Public visé",
          "Mots clés (15 maximum)",
          "Biographie de l'auteur",
          "Sommaire ou extraits représentatifs (3 maximum)"
        ]
      },
      communication: {
        title: "Communication",
        description: "Nous mettons en place une stratégie de communication complète :",
        items: [
          "Communiqué de presse et services de presse",
          "5 à 6 interviews proposées",
          "Présence sur nos réseaux sociaux et chaîne YouTube",
          "Contacts avec des journalistes partenaires",
          "Votre implication est cruciale pour le succès"
        ]
      },
      cta: "Soumettre votre manuscrit"
    },
    contact: {
      title: "Contactez-nous",
      subtitle: "Nous sommes à votre écoute",
      info: {
        address: "VA Éditions / Quid Novi"
      },
      form: {
        name: "Nom complet",
        email: "Email",
        subject: "Sujet",
        message: "Message",
        submit: "Envoyer",
        success: "Message envoyé avec succès !",
        error: "Erreur lors de l'envoi du message"
      }
    },
    submission: {
      title: "Soumettre un Manuscrit",
      subtitle: "Rejoignez nos auteurs",
      form: {
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email",
        phone: "Téléphone",
        title: "Titre de l'ouvrage",
        subtitle: "Sous-titre",
        collection: "Collection souhaitée",
        collections: ["Politique", "Histoire", "Faits de société", "Économie", "Autre"],
        summary: "Résumé (max 1000 caractères)",
        targetAudience: "Public visé",
        keywords: "Mots clés (séparés par des virgules)",
        biography: "Biographie de l'auteur",
        manuscript: "Manuscrit (PDF ou DOCX)",
        coverPage: "Quatrième de couverture",
        consent: "J'accepte que mes données soient utilisées dans le cadre de ma soumission",
        submit: "Soumettre le manuscrit",
        success: "Manuscrit soumis avec succès ! Nous vous contacterons sous peu.",
        error: "Erreur lors de la soumission"
      }
    },
    footer: {
      about: "À propos",
      aboutText: "Quid Novi est un éditeur généraliste indépendant dédié à la transmission du savoir.",
      quickLinks: "Liens rapides",
      legal: "Mentions légales",
      privacy: "Politique de confidentialité",
      rights: "Tous droits réservés"
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      authors: "Authors",
      contact: "Contact"
    },
    home: {
      hero: {
        title: "Quid Novi",
        subtitle: "Independent general publisher",
        description: "Transmitting knowledge through traditional and digital books, including on specialized subjects",
        cta: "Submit a manuscript"
      },
      mission: {
        title: "Our Mission",
        content: "Quid Novi is an independent general publisher whose mission is to transmit knowledge through traditional and digital books, including on specialized subjects. Each book is part of a collection with its own graphic charter."
      },
      collections: {
        title: "Our Collections",
        items: [
          { name: "Politics", description: "Political and geopolitical analyses" },
          { name: "History", description: "Contemporary and historical history" },
          { name: "Social Issues", description: "Current societal challenges" },
          { name: "Economics", description: "Economic and financial analyses" }
        ]
      },
      diffusion: {
        title: "Bookstore Distribution",
        content: "Our books are distributed in bookstores by our professional distributor"
      }
    },
    about: {
      title: "About Quid Novi",
      subtitle: "An independent general publisher",
      content: [
        "Quid Novi is an independent general publisher whose mission is to transmit knowledge through traditional and digital books, including on specialized subjects.",
        "Each book must be part of a collection with its own graphic charter. Books are distributed in bookstores by our distributor.",
        "We are also known as VA Éditions for some of our publications."
      ],
      values: {
        title: "Our Values",
        items: [
          { title: "Editorial Excellence", description: "Quality and rigor in every publication" },
          { title: "Independence", description: "Freedom of choice and expression" },
          { title: "Transmission", description: "Sharing knowledge with the widest audience" },
          { title: "Innovation", description: "Traditional and digital formats" }
        ]
      }
    },
    authors: {
      title: "Authors Space",
      subtitle: "Publish with Quid Novi",
      intro: "Do you have a manuscript and want to publish it? Discover our publishing process and submission procedures.",
      process: {
        title: "Publishing Process",
        steps: [
          {
            number: "01",
            title: "Declaration of Interest",
            description: "Your project or manuscript is subject to a declaration of interest from us and a contract is signed."
          },
          {
            number: "02",
            title: "Manuscript Submission",
            description: "Send your manuscript formatted according to our standards, with a title and back cover."
          },
          {
            number: "03",
            title: "Reading and Revisions",
            description: "A sample reading is performed. Several back-and-forth exchanges may be necessary for formatting."
          },
          {
            number: "04",
            title: "Final Approval",
            description: "Once the manuscript is finalized, we send you the final approval to launch printing."
          },
          {
            number: "05",
            title: "Publication",
            description: "The book is generally released 5 months after listing. Author involvement is essential."
          }
        ]
      },
      requirements: {
        title: "Manuscript Requirements",
        format: {
          title: "Format",
          items: [
            "WORD document in A5 format (14.8 x 21 cm)",
            "100 to 350 pages",
            "130,000 to 500,000 characters (excluding spaces)",
            "Times New Roman font size 12",
            "Margins: top 2, bottom 2, inside 2, outside 2, binding 1"
          ]
        },
        structure: {
          title: "Structure",
          items: [
            "2 blank pages at the beginning and end",
            "Page 3: First Name LAST NAME, TITLE, subtitle, \"VA Éditions\"",
            "Page 5: table of contents",
            "Page numbering in footer (centered, from bottom: 1.25)"
          ]
        }
      },
      argumentaire: {
        title: "Sales Sheet",
        description: "To present your work to our sales team, you will need to create a sales sheet 5 months before release:",
        items: [
          "Concise summary (max 1000 characters)",
          "Strengths (maximum 4)",
          "Target audience",
          "Keywords (maximum 15)",
          "Author biography",
          "Table of contents or representative excerpts (maximum 3)"
        ]
      },
      communication: {
        title: "Communication",
        description: "We implement a comprehensive communication strategy:",
        items: [
          "Press release and press services",
          "5 to 6 interviews offered",
          "Presence on our social networks and YouTube channel",
          "Contacts with partner journalists",
          "Your involvement is crucial for success"
        ]
      },
      cta: "Submit your manuscript"
    },
    contact: {
      title: "Contact Us",
      subtitle: "We're here to listen",
      info: {
        email: "camille.chevolot@vapress.fr",
        address: "VA Éditions / Quid Novi"
      },
      form: {
        name: "Full name",
        email: "Email",
        subject: "Subject",
        message: "Message",
        submit: "Send",
        success: "Message sent successfully!",
        error: "Error sending message"
      }
    },
    submission: {
      title: "Submit a Manuscript",
      subtitle: "Join our authors",
      form: {
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        phone: "Phone",
        title: "Book title",
        subtitle: "Subtitle",
        collection: "Desired collection",
        collections: ["Politics", "History", "Social Issues", "Economics", "Other"],
        summary: "Summary (max 1000 characters)",
        targetAudience: "Target audience",
        keywords: "Keywords (separated by commas)",
        biography: "Author biography",
        manuscript: "Manuscript (PDF or DOCX)",
        coverPage: "Back cover",
        consent: "I agree that my data will be used for my submission",
        submit: "Submit manuscript",
        success: "Manuscript submitted successfully! We will contact you shortly.",
        error: "Submission error"
      }
    },
    footer: {
      about: "About",
      aboutText: "Quid Novi is an independent general publisher dedicated to the transmission of knowledge.",
      quickLinks: "Quick Links",
      legal: "Legal Notice",
      privacy: "Privacy Policy",
      rights: "All rights reserved"
    }
  }
};

// Mock submission storage
export const mockSubmissions = [];

export const submitManuscript = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      mockSubmissions.push({
        ...data,
        id: Date.now(),
        submittedAt: new Date().toISOString()
      });
      resolve({ success: true, id: mockSubmissions.length });
    }, 1000);
  });
};

export const sendContactMessage = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Message sent" });
    }, 800);
  });
};
